import React from "react";
import { Input, Button, Space, Row, Col, Typography } from "antd";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface TaskTemplateFiltersProps {
  onSearch: (value: string) => void;
  onAddTemplate: () => void;
  totalTemplates: number;
}

const TaskTemplateFilters: React.FC<TaskTemplateFiltersProps> = ({
  onSearch,
  onAddTemplate,
  totalTemplates,
}) => {
  return (
    <Space direction="vertical" style={{ width: "100%" }} size="middle">
      <Row gutter={[16, 16]} align="middle">
        <Col flex="auto">
          <Input
            prefix={<SearchOutlined />}
            placeholder="Search task templates..."
            onChange={(e) => onSearch(e.target.value)}
            style={{ maxWidth: 400 }}
          />
        </Col>
        <Col>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={onAddTemplate}
          >
            Add Template
          </Button>
        </Col>
      </Row>

      <Text type="secondary">
        {totalTemplates} template{totalTemplates !== 1 ? "s" : ""} found
      </Text>
    </Space>
  );
};

export default TaskTemplateFilters;
